module.exports = __webpack_public_path__ + "media/images/home/flow_r_index_2-041dc8bdbf6ef19a1c2fe02f16726e49.svg";